import {
    CATEGORYCOURSEAVAILABLE_BEGIN,
    CATEGORYCOURSEAVAILABLE_ADD,
    CATEGORYCOURSEAVAILABLE_FAILURE,
} from 'app/actions/CategoryCourseAvailableActions';

const initialState = {
    byId: {},
    allIds: [],
    isLoading: false,
};

export default function CategoryCourseAvailableReducer(state = initialState, action) {
    switch (action.type) {
        case CATEGORYCOURSEAVAILABLE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case CATEGORYCOURSEAVAILABLE_ADD:
            let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
            let byId = {
                ...state.byId,
                ...action.payload.data.byId
            };
            return {
                ...state,
                allIds,
                byId,
                isLoading: false,
            };
        case CATEGORYCOURSEAVAILABLE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
};

export const getCategoryCourseAvailable = state => {
    return state.allIds.map(id => state.byId[id]);
}